import { ACCESS_TOKEN_KEY, getEnv } from '@src/core/config';
import Axios from 'axios';
import { routesConfig } from '@src/core/routes';

export const axios = Axios.create({
  baseURL: getEnv('REACT_APP_API_BASE_URL'),
  responseType: 'json',
  timeout: 60000,
});

axios.interceptors.request.use((request: any) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
  }
  request.headers["Content-Type"] = "application/json";
  return request;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 412) {
      window.location.href = routesConfig.agreement;
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

